import { useQuery } from '@tanstack/react-query'
import { listWorkerRequirements } from 'api/admin/credentials/listWorkerRequirements'
import { credentialsKeys } from './keys'

export function useWorkerRequirementsQuery() {
  return useQuery({
    queryKey: credentialsKeys.workerRequirementsList(),
    queryFn: () => listWorkerRequirements(),
  })
}
